
export default {
  // Company Information
  companyInformation: "معلومات العميل",
  brandInformation: "معلومات العلامة التجارية",
  contactInformation: "معلومات الاتصال",
  companyName: "اسم الشركة",
  brandName: "اسم العلامة التجارية",
  personInCharge: "الشخص المسؤول",
  jobTitle: "المسمى الوظيفي",
  campaignEmail: "البريد الإلكتروني",
  mobileNumber: "رقم الجوال",
  enterCompanyName: "أدخل اسم الشركة الخاصة بك",
  enterBrandName: "أدخل اسم العلامة التجارية الخاصة بك",
  enterPersonName: "أدخل الاسم الكامل للشخص المسؤول",
  enterJobTitle: "أدخل المسمى الوظيفي",
  enterEmail: "أدخل عنوان البريد الإلكتروني الخاص بك",
  enterMobile: "أدخل رقم الجوال الخاص بك",
} as const;
